import { SET_AUTO_APPLIED_VOUCHER } from 'actions/actionConstants'
import type { AppAction } from 'actions/types/ActionTypes'
import { isMetasearchDiscountEnabled } from 'lib/metasearch/metasearchDiscountContext'
import { createMetasearchDiscountVoucher } from 'lib/metasearch/metasearchVoucherApi'
import { serialiseOccupancy } from 'lib/search/searchUtils'
import { getSourceForProperty } from 'selectors/offerSelectors'
import { SOURCE_TYPES } from 'constants/source'

const SUPPORTED_GHA_VOUCHER_OCCUPANCIES = new Set(['1', '2'])

export interface CreateGhaVoucherInput {
  token?: string
  propertyId?: string
  checkIn?: string
  checkOut?: string
  rooms?: Array<App.Occupants>
}

function isSupportedGhaVoucherOccupancy(occupancy: Array<string>): boolean {
  return occupancy.length === 1 && SUPPORTED_GHA_VOUCHER_OCCUPANCIES.has(occupancy[0])
}

export function createGhaVoucher(input: CreateGhaVoucherInput): AppAction {
  return async(dispatch, getState) => {
    if (
      !isMetasearchDiscountEnabled() ||
      !input.token ||
      !input.propertyId ||
      !input.checkIn ||
      !input.checkOut ||
      !input.rooms?.length
    ) {
      return
    }

    const occupancy = serialiseOccupancy(input.rooms)
    if (!isSupportedGhaVoucherOccupancy(occupancy)) {
      return
    }

    const state = getState()
    const source = getSourceForProperty(state, input.propertyId)
    const response = await createMetasearchDiscountVoucher({
      token: input.token,
      propertyId: input.propertyId,
      checkIn: input.checkIn,
      checkOut: input.checkOut,
      occupancy,
      region: state.geo.currentRegionCode,
      isCugRate: source.includes(SOURCE_TYPES.CUG_METASEARCH),
    })

    if (response.voucherId) {
      dispatch({
        type: SET_AUTO_APPLIED_VOUCHER,
        data: response.voucherId,
      })
    }
  }
}
